<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-12">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <!-- <div class="form-group col-md-3">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div> -->
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>

<ng-template #enviarTemplateResport>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Proceso - Liquidación'" [label]="'Proceso - Liquidación *'" [id]="'idLiquidacion'"
          formControlName="idLiquidacion" [control]="formulario.get('idLiquidacion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Mes'" [label]="'Mes *'" [id]="'mesDescripcion'"
          formControlName="mesDescripcion" [control]="formulario.get('mesDescripcion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Año'" [label]="'Año *'" [id]="'anio'"
          formControlName="anio" [control]="formulario.get('anio')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Usuario de Carga'"
          [label]="'Usuario de Carga *'" [id]="'usuario'" formControlName="usuario"
          [control]="formulario.get('usuario')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Tipo de Vendedor'" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorDescripcion'"
          formControlName="tipoVendedorDescripcion" [control]="formulario.get('tipoVendedorDescripcion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Vendedor'" [label]="'Vendedor *'" [id]="'nombreVendedor'"
          formControlName="nombreVendedor" [control]="formulario.get('nombreVendedor')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Estado Proceso'"
          [label]="'Estado Proceso *'" [id]="'estadoProceso'" formControlName="estadoProceso"
          [control]="formulario.get('estadoProceso')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Estado Cierre'"
          [label]="'Estado Cierre *'" [id]="'estadoCierre'" formControlName="estadoCierre"
          [control]="formulario.get('estadoCierre')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'"
          [placeholder]="'Total canales / Tipo Vendedor'" [label]="'Total canales / Tipo Vendedor *'"
          [id]="'totalTipoLiquida'" formControlName="totalTipoLiquida"
          [control]="formulario.get('totalTipoLiquida')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Total Empleados'"
          [label]="'Total Empleados *'" [id]="'totalEmplLiquida'" formControlName="totalEmplLiquida"
          [control]="formulario.get('totalEmplLiquida')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Total Empleados'"
          [label]="'Total Empleados *'" [id]="'totalPagoLiquida'" formControlName="totalPagoLiquida"
          [control]="formulario.get('totalPagoLiquida')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-3">
        <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Fecha Procesamiento'" [label]="'Fecha Procesamiento *'" [id]="'fechaProceso'"
          formControlName="fechaProceso" [control]="formulario.get('fechaProceso')"></app-lfsa-input>
      </div>
      <div class="form-group col-12">
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'"
          [placeholder]="'Motivo'" [label]="'Motivo *'" [id]="'motivoRevision'"
          formControlName="motivoRevision" [control]="formulario.get('motivoRevision')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-12">
        <div class="row">
          <div class="form-group col-12 col-md-2">
            <button class={{DAT_BTNCSS.danger}} (click)="limpiarRegresar()">Regresar</button>
          </div>
          <div class="form-group col-12 col-md-8"></div>
          <div class="form-group col-12 col-md-2">
            <button class={{DAT_BTNCSS.success}} (click)="habilitarPeriodo()">Aperturar Periodo</button>
          </div>
        </div>
      </div>
    </div>
    <!-- <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario> -->
  </div>
</ng-template>